import { Box, Text, Button, Group, Badge } from '@mantine/core';
import { IconInfoCircle } from '@tabler/icons-react';

const StatsResume = ({ unitType = 'f', countEvidences, countWeakness, countStrengths, buttonVisible ,onClick }) => {
  // Datos de las estadísticas
  const stats = [
    { label: 'Evidencias', count: countEvidences, color: '#E72166' },
    { label: 'Debilidades', count: countWeakness, color: 'red' },
    { label: 'Fortalezas', count: countStrengths, color: 'green' },
  ];

  return (
    <Box>
      <Group grow preventGrowOverflow={false} wrap="nowrap">
        {stats.map((stat, index) => (
          <Badge
            key={index}
            radius="lg"
            variant={unitType === 'f' ? 'dot' : 'default'}
            size={unitType === 'f' ? 'lg' : 'lg'}
            color={stat.color}
            //p="sm"
          >
            {stat.label} : {stat.count}
          </Badge>
        ))}
        {buttonVisible && (
          <Button
            radius="lg"
            variant={unitType === 'f' ? 'filled' : 'filled'}
            size={unitType === 'f' ? 'compact-sm' : 'compact-sm'}
            color="blue"
            leftSection={<IconInfoCircle size={18}/>}
            onClick={onClick}
          >
            <Text fw={500} size='xs' >
              VER DETALLE
            </Text>
          </Button>
        )}
      </Group>
    </Box>
  );
};

export default StatsResume;